import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

interface ActivePeriodResponse {
    period_id: number;
    name: string;
    start_date: string;
    end_date: string;
    is_active: boolean;
}

export function useActivePeriod() {
    return useQuery({
        queryKey: ["active-period"],
        queryFn: async () => {
            const { data } = await axiosClient.get<ActivePeriodResponse>("/periods/active");
            if (!data) return null;

            // 🧩 Normalisasi supaya frontend selalu pakai "id"
            return {
                id: data.period_id,
                name: data.name,
                start_date: data.start_date,
                end_date: data.end_date,
                is_active: data.is_active,
            };
        },
        retry: false,
    });
}
